<template>
	<div class="servers page">
		<div class="list" :style="slider_style">

			<div class="server">
				<img src="/img/servers/8.jpg">

				<div class="info">
					<div class="wrap">
						<div class="row">
							<div class="title">Max Online:</div>
							<div class="text">50 Players</div>
						</div>
						<div class="row">
							<div class="title">Max Group Size:</div>
							<div class="text">2 Players</div>
						</div>
						<div class="row">
							<div class="title">IP Address:</div>
							<div class="text">64.40.9.171:28041</div>
						</div>
						<div class="desc">
							Extremely action packed server. Tiny map with a lot of custom and vanilla monuments. Kill or be killed, nothing more to it. If you seek for peace, this is the wrong place for you. Constant pvp and betrayals all over the place. Getting your first base down is a challenge. Master it or be a looser!
						</div>
					</div>
				</div>
			</div>

			<div class="server">
				<img src="/img/servers/1.jpg">

				<div class="info">
					<div class="wrap">
						<div class="row">
							<div class="title">Max Online:</div>
							<div class="text">50 Players</div>
						</div>
						<div class="row">
							<div class="title">Max Group Size:</div>
							<div class="text">3 Players</div>
						</div>
						<div class="row">
							<div class="title">IP Address:</div>
							<div class="text">64.40.9.171:28040</div>
						</div>
						<div class="desc">
							Extremely action packed server. Tiny map with a lot of custom and vanilla monuments. Kill or be killed, nothing more to it. If you seek for peace, this is the wrong place for you. Constant pvp and betrayals all over the place. Getting your first base down is a challenge. Master it or be a looser!
						</div>
					</div>
				</div>
			</div>

			<div class="server">
				<img src="/img/servers/mods.png">
				<div class="info">
					<div class="wrap mods">
						- 2x Farm, Loot & Crafting<br>
						- Detailed Custom Monuments<br>
						- Anti Roof Camp Plugin<br>
						- FREE Furnace Splitter<br>
						- FREE Quick Smelt<br>
						- Increased Stack Sizes<br>
						- Adjusted Bag Timers<br>
						- Discord Item Rewards<br>
						- Custom NPC's<br>
						- Tool Cupboard Limitation (2)<br>
						- Kill / Death Ratio Plugin<br>
						- Drive cars without Parts<br>
						- Neutral Animals<br>
						- No Armor on Horses<br>
						- Faster Recycling<br>
						- Skinbox (VIP)<br>
						- Skip Queue (VIP)<br>
						- NO PAY TO WIN
					</div>
				</div>
			</div>

			<!-- <div class="server">
				<img src="/img/servers/5.jpg">

				<div class="info">
					<div class="wrap">
						<div class="row">
							<div class="title">Max online:</div>
							<div class="text">60 players</div>
						</div>
						<div class="row">
							<div class="title">Max group size:</div>
							<div class="text">3 players</div>
						</div>
						<div class="row">
							<div class="title">IP address:</div>
							<div class="text">64.40.9.171:28041</div>
						</div>
						<div class="desc">
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat quisquam eum consectetur doloremque error? Aliquam, cupiditate. Dolores voluptatum, placeat dicta totam, saepe quam nostrum tenetur voluptates, quia minima maiores distinctio! Привет, эта пасхалка для тебя ахахаха
						</div>
					</div>
				</div>
			</div> -->
		</div>

		<div class="nav">
			<i class="fa fa-angle-left" @click="moveSlide(-1)" :class="{last: (server == 0)}"></i>
			<div class="name">{{ servers[server].name }}<!--small>{{ server + 1 }} / {{ servers.length }}</small--></div>
			<i class="fa fa-angle-right" @click="moveSlide(1)" :class="{last: (server == servers.length - 1)}"></i>
		</div>
	</div>
</template>


<script>
export default {
	name: "Servers",
	data: () => ({
		server: 0,

		servers: [
			{ name: "OneGrid Duo", max: 50 },
			{ name: "OneGrid Trio", max: 50 },
			{ name: "Server Features", max: 70 },
		],
	}),

	methods: {
		moveSlide(num) {
			if (
				this.server + num >= this.servers.length ||
				this.server + num < 0
			)
				return;

			this.server += num;
		},
	},

	computed: {
		slider_style() {
			var percent = this.server * 33.333333;
			return `transform: translateX(-${percent}%)`;
		},
	},
};
</script>


<style lang="scss">
.servers.page {
	height: 100%;
	padding: 0px !important;

	.list {
		height: 100%;
		width: 3000px;
		width: max-content;
		display: flex;
		justify-content: flex-start;
		transition: 0.5s;
	}

	.server {
		width: 680px;
		height: 100%;
		position: relative;

		img {
			position: absolute;
			top: 0px;
			left: 0px;
			right: 0px;
			bottom: 0px;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.info {
			position: absolute;
			top: 0px;
			left: 0px;
			right: 0px;
			bottom: 0px;
			width: 100%;
			height: 100%;
			background: linear-gradient(
				to bottom,
				rgba(0, 0, 0, 0.2),
				rgba(0, 0, 0, 0.95)
			);

			display: flex;
			justify-content: center;
			align-items: flex-end;
			// align-content: center;
			flex-wrap: wrap;

			.wrap {
				width: 46%;
				margin-bottom: 110px;

				&.mods {
					// width: 40%;
					// font-size: 16px;
					// font-weight: 300;
					// text-align: center;
					width: 35%;
					font-size: 16px;
					font-weight: 600;
					position: relative;
					left: 45px;
					top: 10px;
				}
			}

			.row {
				width: 100%;
				display: flex;

				justify-content: space-between;
				align-items: flex-start;
			}

			.desc {
				margin-top: 15px;
				text-align: justify;
				opacity: 0.85;
				font-size: 14px;
				font-weight: 400;
			}
		}
	}

	.nav {
		position: absolute;
		left: 0px;
		bottom: 0px;
		right: 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 30px;
		font-size: 40px;
		cursor: pointer;

		.name {
			font-weight: 600;
			position: relative;
			text-align: center;
			line-height: 1.1;

			small {
				opacity: 0.3;
				font-size: 14px;
				display: block;
			}
		}

		i {
			transition: 0.25s;

			&:hover {
				filter: drop-shadow(0px 0px 8px white);
			}

			&.last {
				opacity: 0.1;
			}
		}
	}

	@media screen and (max-width: 1200px) and (orientation: portrait) {
		.list {
			height: 63vh;
		}

		.server {
			width: 92vw;

			.info {
				align-items: center;
				font-size: 4vw;

				.desc {
					font-size: 3vw;
				}

				.wrap {
					margin: 5vw;
					width: initial;

					&.mods {
						position: initial;
						width: 60%;
						font-size: 3.75vw;
						margin: 0px;
						text-align: center;
					}
				}
			}
		}

		.nav {
			position: initial;

			.name {
				font-size: 6vw;
			}
		}
	}
}
</style>